/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_Desc_1Inputs */

const et_benefits_desc_1 = /** @type {(inputs: Benefits_Desc_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75% kõigist otsijatest läheb top 3 tulemusele. Kui Teid seal pole, olete nähtamatu.`)
};

const en_benefits_desc_1 = /** @type {(inputs: Benefits_Desc_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75% of all searchers click the top 3 results. If you're not there, you're invisible.`)
};

/**
* | output |
* | --- |
* | "75% of all searchers click the top 3 results. If you're not there, you're invisible." |
*
* @param {Benefits_Desc_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_desc_1 = /** @type {((inputs?: Benefits_Desc_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_Desc_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_desc_1(inputs)
	return en_benefits_desc_1(inputs)
});